// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumb_container__-qDfv","item":"Breadcrumb_item__JcNCm","active":"Breadcrumb_active__vNwSS"};